export const normalizeFilterItem = (rawData) => {
  const {
    adult = '', // 'y' | 'n'
    value = '', // value of query parameter
    title = '',
  } = rawData
  return {
    adult,
    value,
    title,
  }
}

export const normalizeFilter = (rawData) => {
  const {
    key = '', // genre | orderby
    default: _default = '',
    item_list: itemList = [],
  } = rawData

  return {
    key,
    _default,
    itemList: itemList.map(normalizeFilterItem),
  }
}
